"use client";
import Loader from "@/components/Loader";
import useMediaQuery from "@/utils/hooks/useMediaQuery";
import { Suspense } from "react";
import { Search } from "../Search/GlobalSearch";

export default function MobileSearchWrapper({
  headerData,
  searchStaticAEMData,
}: {
  headerData: any;
  searchStaticAEMData: any;
}) {
  const mediaQueryValue = useMediaQuery();
  const isMobile =
    typeof mediaQueryValue === "number" ? mediaQueryValue <= 1023 : false;
  return isMobile ? (
    <Suspense fallback={<Loader />}>
      <Search
        placeholder={headerData["header"]?.searchplaceholder}
        className="search-tablet-view [&_.inputWrapper]:!z-0"
        searchStaticAEMData={searchStaticAEMData}
      />
    </Suspense>
  ) : (
    <></>
  );
}
